import { api } from "./api.service";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useGetTransactions = () => {
  return useMutation({
    mutationFn: () => api.get("/aznio/transactions"),
  });
};

export const useGetTransactionById = () => {
  return useMutation({
    mutationFn: (txId: string) => {
      return api.get(`/aznio/transactions/${txId}`);
    },
  });
};

export const useStartTransaction = () => {
  return useMutation({
    mutationFn: (data: any) => api.post("/aznio/start", data),
  });
};

export const useGetPaymentTransactions = () => {
  return useQuery({
    queryKey: ["get-payments"],
    queryFn: async () => {
      const response = await api.get(`/transactions/payment`);
      return await response.data.data;
    },
  });
};
